'use client'

import usePolymarketTrading, { type TradingStatus } from '@/hooks/polymarket/usePolymarketTrading'
import type { RelayClient } from '@polymarket/builder-relayer-client'
import type { ClobClient } from '@polymarket/clob-client'
import { type ReactNode, createContext, useContext } from 'react'

interface TradingContextType {
	// New simplified API
	status: TradingStatus
	currentAction: string | null
	error: Error | null
	clobClient: ClobClient | null
	relayClient: RelayClient | null
	safeAddress: string | undefined
	eoaAddress: string | undefined
	retry: () => void
	// Convenience getter
	isReady: boolean
}

const TradingContext = createContext<TradingContextType | null>(null)

export function useTrading() {
	const ctx = useContext(TradingContext)
	if (!ctx) {
		throw new Error('useTrading must be used within TradingProvider')
	}
	return ctx
}

export default function TradingProvider({ children }: { children: ReactNode }) {
	const trading = usePolymarketTrading()

	return (
		<TradingContext.Provider
			value={{
				...trading,
				isReady: trading.status === 'ready',
			}}
		>
			{children}
		</TradingContext.Provider>
	)
}
